/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIGuestRequestFileFileType } from './APIGuestRequestFileFileType';
import {
    APIGuestRequestFileFileTypeFromJSON,
    APIGuestRequestFileFileTypeFromJSONTyped,
    APIGuestRequestFileFileTypeToJSON,
} from './APIGuestRequestFileFileType';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIGuestRequestFile
 */
export interface APIGuestRequestFile {
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestFile
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestFile
     */
    guestRequest: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestFile
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestFile
     */
    document?: string | null;
    /**
     * 
     * @type {APIGuestRequestFileFileType}
     * @memberof APIGuestRequestFile
     */
    fileType?: APIGuestRequestFileFileType | null;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestFile
     */
    readonly name: string;
    /**
     * 
     * @type {Date}
     * @memberof APIGuestRequestFile
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof APIGuestRequestFile
     */
    readonly size: number;
}

/**
 * Check if a given object implements the APIGuestRequestFile interface.
 */
export function instanceOfAPIGuestRequestFile(value: object): value is APIGuestRequestFile {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('guestRequest' in value) || value['guestRequest'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function APIGuestRequestFileFromJSON(json: any): APIGuestRequestFile {
    return APIGuestRequestFileFromJSONTyped(json, false);
}

export function APIGuestRequestFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestRequestFile {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'guestRequest': json['guest_request'],
        'key': json['key'] == null ? undefined : json['key'],
        'document': json['document'] == null ? undefined : json['document'],
        'fileType': json['file_type'] == null ? undefined : APIGuestRequestFileFileTypeFromJSON(json['file_type']),
        'name': json['name'],
        'createdAt': (new Date(json['created_at'])),
        'size': json['size'],
    };
}

export function APIGuestRequestFileToJSON(value?: Omit<APIGuestRequestFile, 'self'|'name'|'created_at'|'size'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'guest_request': value['guestRequest'],
        'key': value['key'],
        'document': value['document'],
        'file_type': APIGuestRequestFileFileTypeToJSON(value['fileType']),
    };
}

